import { render, staticRenderFns } from "./SharePosition.vue?vue&type=template&id=ebe81ab4&scoped=true&"
import script from "./SharePosition.vue?vue&type=script&lang=js&"
export * from "./SharePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe81ab4",
  null
  
)

export default component.exports